import React from "react";
import * as S from "./CheckboxRound.style";

function CheckboxRound({ checkFunction, itemCheckbox, selectedItemId, fontSize }) {

  return (
    <S.CheckboxRoundDiv 
      fontSize={fontSize}
    >
      <div 
        className="content-checkbox"
        onClick={() => checkFunction(itemCheckbox)}
      >
        <i className={`icon-checkbox icon ${selectedItemId === itemCheckbox.id ? "zaia-icon-check" : "zaia-check-icon2"}`} />
        <div className="text-checkbox" onClick={() => checkFunction(itemCheckbox)}>{itemCheckbox.name}</div>
      </div>
    </S.CheckboxRoundDiv>
  );
}

export default CheckboxRound;
